import React from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { db } from '../../../config/firebaseConfig';
import { connect } from 'react-redux';
import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import NavItems from './NavItems';
import { Nav, Navbar, Container } from 'react-bootstrap';
import '@animxyz/core';
import { XyzTransition } from '@animxyz/react';


function NavBar({ theme, setTheme, editLocalStorageTheme }) {
  const [expanded, setExpanded] = useState(false);
  const { currentUser } = useAuth();

  useEffect(() => {
    if (!currentUser) return;

    const unsubscribe = db.collection('users').doc(currentUser.uid).onSnapshot(
      (doc) => {
        if (doc.exists) {
          const data = doc.data();
          console.log("Données utilisateur reçues :", data);
        }
      },
      (error) => {
        console.error("Erreur de chargement Firestore :", error);
      }
    );
    return unsubscribe;
  }, [currentUser]);

  return (
    <React.Fragment>
      <XyzTransition
        appear
        xyz='fade small out-down appear delay-1 ease-out-back'
      >
        <Navbar
          collapseOnSelect
          expanded={expanded}
          onToggle={(isOpen) => setExpanded(isOpen)}
          expand='lg'
          bg='primary'
          variant='dark'
          sticky='top'
        >
          <Container>
            <NavLink to='/' className='navbar-brand' onClick={() => setExpanded(false)}>
              <Navbar.Brand id='title-navbar' as="span">
                me<span>mento</span>
              </Navbar.Brand>
            </NavLink>


            <Navbar.Toggle aria-controls='responsive-navbar-nav' className="order-lg-2" />
            <Navbar.Collapse id='responsive-navbar-nav' className="order-lg-1">
              <Nav className="me-auto align-items-lg-center">
              </Nav>
              <div onClick={() => setExpanded(false)}>
                <NavItems theme={theme} setTheme={setTheme} editLocalStorageTheme={editLocalStorageTheme}/>
              </div>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </XyzTransition>
    </React.Fragment>
  );
}

export default connect()(NavBar);
